import { HalfCircleSpinner } from 'epic-spinners';

import ReadMore from 'vue-read-more';
import Toasted from 'vue-toasted';
import Swal from 'sweetalert2';

import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews';

let sentryPref = document?.documentElement?.getAttribute('data-admin-without-vue');
let jsSentryDisabled = document?.documentElement?.getAttribute('data-js-sentry-disabled');

if(!jsSentryDisabled) {
    if (sentryPref) {
        require('@galaxy/modules/Core/resources/js/sentry/withoutVue');
    } else {
        require('@galaxy/modules/Core/resources/js/sentry/withVue');
    }
}

window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Add token to jQuery Ajax.
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': token,
    },
});

// Global axios error interceptor: show friendly messages instead of silent failures.
window.axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;

        // Network error (no response at all — connection lost, timeout, etc.)
        if (!error.response && !axios.isCancel(error)) {
            Swal.fire({
                icon: 'warning',
                title: 'Geen verbinding',
                text: 'Er kon geen verbinding worden gemaakt met de server. Controleer je internetverbinding en probeer het opnieuw.',
                confirmButtonText: 'Sluiten',
                confirmButtonColor: '#4f46e5',
            });
            return Promise.reject(error);
        }

        if (status === 419) {
            Swal.fire({
                icon: 'warning',
                title: 'Sessie verlopen',
                text: 'Je sessie is verlopen. De pagina wordt opnieuw geladen.',
                confirmButtonText: 'Herlaad pagina',
                confirmButtonColor: '#4f46e5',
                allowOutsideClick: false,
            }).then(() => window.location.reload());
        } else if (status === 401) {
            window.top.location.reload();
        } else if (status === 403) {
            Swal.fire({
                icon: 'error',
                title: 'Geen toegang',
                text: 'Je hebt geen rechten om deze actie uit te voeren.',
                confirmButtonText: 'Sluiten',
                confirmButtonColor: '#4f46e5',
            });
        } else if (status >= 500) {
            Swal.fire({
                icon: 'error',
                title: 'Er ging iets mis',
                text: 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw of neem contact op met support.',
                confirmButtonText: 'Sluiten',
                confirmButtonColor: '#4f46e5',
            });
        }

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// Needed for OverviewRootBlockToolbar.vue which is in the canvas editor iframe.
window.Swal = Swal;

// Init Moment.
window.moment = require('moment');
window.moment.locale('nl');

require('moment-duration-format');

// Init Datatables.
require('datatables.net'); // TODO Move to view?
require('datatables.net-bs4');

// Init the required common tools.
require('@galaxy/modules/Core/resources/js/View.js');
require('@galaxy/modules/Core/resources/js/vue.js');
require('@galaxy/modules/Core/resources/js/livewire.js'); // needs to be after vue was loaded
require('@galaxy/modules/Core/resources/js/index.js');
require('@galaxy/modules/Core/resources/js/viewportHeightFix.js');

/**
 * Init Vue.
 */
Vue.component('HalfCircleSpinner', HalfCircleSpinner);

Vue.use(ReadMore);

$(() =>
    Vue.use(Toasted, {
        //theme: 'bootstrap',
        position: 'bottom-center',
        duration: 5 * 1000,
    })
);

AutoloadViews.load('admin::dashboard', require.context('./dashboard', true, /.(js|vue)$/));
AutoloadViews.load('admin::layout', require.context('./layout', true, /.(js|vue)$/));
AutoloadViews.load('admin::user', require.context('./user', true, /.(js|vue)$/));

Vue.component('search', require('./dashboard/Search').default);
Vue.component('password', require('./user/Password').default);

// Media library admin components — registers <media-library> et al. used by the
// /admin/modules/media-library page (was never wired into the admin bundle).
require('@galaxy/modules/MediaLibrary/resources/js/bootstrap.admin.js');

// AI Translate button handler
require('./translate-button.js');
